import { Helmet } from "react-helmet-async";
import Hero from "../components/Hero";
import WelcomeSection from "../components/WelcomeSection";
import TopRatedProperties from "../components/TopRatedProperties";
import SocialMediaSection from "../components/SocialMediaSection";
import WhyInvestSolapur from "../components/WhyInvestSolapur";
import InvestmentVariations from "../components/InvestmentVariations";
import FeatureHighlights from "../components/FeatureHighlights";
import LocationAdvantages from "../components/LocationAdvantages";
import Testimonials from "../components/Testimonials";
import ContactForm from "../components/ContactForm";

const Index = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* ✅ SEO & Meta Tags */}
      <Helmet>
        {/* --- BASIC META --- */}
        <title>
          Solapur Properties | Skyline Properties | Best Real Estate in Solapur
        </title>
        <meta
          name="description"
          content="Find premium Solapur properties with Skyline Properties. Explore luxurious flats, commercial spaces, and investment plots in Solapur's top locations."
        />
        <meta
          name="keywords"
          content="Solapur properties, Skyline properties, properties in Solapur, Solapur real estate, flats in Solapur, houses for sale in Solapur"
        />
        <link rel="canonical" href="https://skylinepropertiess.com/" />

        {/* --- OPEN GRAPH (For Facebook, WhatsApp, etc.) --- */}
        <meta property="og:title" content="Solapur Properties | Skyline Properties" />
        <meta
          property="og:description"
          content="Explore the best properties in Solapur with Skyline Properties. Find your dream home or investment opportunity today."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://skylinepropertiess.com/" />
        <meta property="og:image" content="https://skylinepropertiess.com/cover.jpg" />

        {/* --- TWITTER META --- */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Solapur Properties | Skyline Properties" />
        <meta
          name="twitter:description"
          content="Find luxurious and affordable properties in Solapur with Skyline Properties."
        />
        <meta name="twitter:image" content="https://skylinepropertiess.com/cover.jpg" />

        {/* --- SCHEMA MARKUP (JSON-LD for Google) --- */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "RealEstateAgent",
              "name": "Skyline Properties Solapur",
              "description": "Skyline Properties offers premium residential, commercial, and investment properties in Solapur.",
              "areaServed": "Solapur, Maharashtra, India",
              "url": "https://skylinepropertiess.com",
              "image": "https://skylinepropertiess.com/cover.jpg",
              "brand": {
                "@type": "Brand",
                "name": "Skyline Properties"
              },
              "sameAs": [
                "https://www.facebook.com/yourpage",
                "https://www.instagram.com/yourprofile"
              ]
            }
          `}
        </script>
      </Helmet>

      {/* --- PAGE SECTIONS --- */}
      <Hero />
      <WelcomeSection />
      <TopRatedProperties />
      <SocialMediaSection />
      <WhyInvestSolapur />
      <InvestmentVariations />
      <FeatureHighlights />
      <LocationAdvantages />
      <Testimonials />
      <ContactForm />
    </div>
  );
};

export default Index;
